import { Component, EventEmitter, HostListener, Input, OnInit, Output } from '@angular/core';
import { ImportsNotUsedAsValues } from 'typescript';
import { BreakParamSearch, ButtonParamSearch, CheckboxParamSearch, DatePickerParamSearch, FloatParamSearch, MultiSelectParamSearch, NumberParamSearch, SelectParamSearch, Select_MoreParamSearch, TextParamSearch } from '../advanced-search.component';

@Component({
  selector: 'app-item',
  templateUrl: './item.component.html',
  styleUrls: ['./item.component.css']
})
export class ItemComponent implements OnInit {


  innerWidth: number | undefined;
  @HostListener('window:resize', ['$event'])
  onResize(event: any) {
    this.innerWidth = window.innerWidth;
  }



  @Input() item : TextParamSearch | NumberParamSearch | FloatParamSearch | SelectParamSearch 
                    | MultiSelectParamSearch | CheckboxParamSearch | DatePickerParamSearch 
                    | ButtonParamSearch | BreakParamSearch | Select_MoreParamSearch | undefined;
  @Output() modelChange = new EventEmitter<TextParamSearch | NumberParamSearch | FloatParamSearch | SelectParamSearch 
                                            | MultiSelectParamSearch | CheckboxParamSearch | DatePickerParamSearch 
                                            | ButtonParamSearch | BreakParamSearch | Select_MoreParamSearch>();

  @Input() child: boolean | undefined;
  // Gestione Select_More
  public selected_more : string | undefined;
  public anno: number;

  constructor() { 
    this.anno = new Date().getFullYear();
  }

  ngOnInit(): void {
    if(this.item instanceof Select_MoreParamSearch || this.item instanceof SelectParamSearch){
      this.selected_more = this.item.initValue;
    }

    if(this.item instanceof DatePickerParamSearch){
      if (this.item.id == "dSCreate") {
        this.item.value = { year: this.anno, month: 1, day: 1 };
      } else if (this.item.id == "dECreate"){
        this.item.value = { year: this.anno, month: 12, day: 31 };
      }
      
    }
    this.innerWidth = window.innerWidth;
  }

  /**
   * Ritorna il valore associato all'attributo values dell'item di tipo SelectParamSearch
   * @param item 
   * @returns 
   */
  getSelectValues(item : any){
    return (item as SelectParamSearch).values;
  }

  getMultiSelectValues(item : any){
    return (item as MultiSelectParamSearch).values;
  }

  getSelect_MoreValues(item : any){
    return (item as Select_MoreParamSearch).values;
  }

  getChildSelect_MoreValues(item : any){
    return this.selected_more && (item as Select_MoreParamSearch).values.filter(i => i.key == this.selected_more).length > 0
              ? (item as Select_MoreParamSearch).values.filter(i => i.key == this.selected_more)[0].body
              : [];
  }


  onSelectChange(val: string[]){
    this.item!.value = {value: val};
  }

  public notifyChange(){
    //console.log(this.item, "notifychange in item.component");
    this.modelChange.emit(this.item);
  }

}
